import { render } from "./UploadImagesModal.vue?vue&type=template&id=2dd58dcc&scoped=true"
import script from "./UploadImagesModal.vue?vue&type=script&lang=js"
export * from "./UploadImagesModal.vue?vue&type=script&lang=js"

import "./UploadImagesModal.vue?vue&type=style&index=0&id=2dd58dcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd58dcc"]])

export default __exports__